import { ReferralsPageContent } from 'components/referrals/2026/ReferralsPageContent';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { usePlayerInvitesAndInvitees } from 'hooks/referrals/usePlayerInvitesAndInvitees';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';

const Referrals = observer(() => {
  useAuthRedirectEffect('/referrals');

  const { loading, invitees, referrerName, referrerAvatarUrl } =
    usePlayerInvitesAndInvitees();

  return (
    <ReferralsPageContent
      loading={loading}
      referees={invitees}
      referrerName={referrerName}
      referrerAvatarUrl={referrerAvatarUrl}
    />
  );
});

export default Referrals;
